/* ==========================================================================
   Zimowy Blask – interakcje strony produktu
   1. wejście elementów        2. pasek informacyjny
   3. galeria (karuzela)       4. pakiety (liczba sztuk)
   5. modale / arkusz mobilny  6. formularz kontaktowy
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('zb-js');

  /* ---------- 1. wejście elementów ---------- */
  (function reveal() {
    if (!document.body.classList.contains('zb-motion')) return;
    var items = document.querySelectorAll('.zb-card, .zb-review, .zb-steps li, .zb-motif-list li');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) return;
    items.forEach(function (el) { el.classList.add('zb-reveal'); });
    var io = new IntersectionObserver(function (entries, self) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        self.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- 2. pasek informacyjny ---------- */
  (function topbar() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var items = Array.prototype.slice.call(bar.querySelectorAll('.zb-topbar__item'));
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3600);
  })();

  /* ---------- 3. galeria ---------- */
  (function gallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return;
    var track = root.querySelector('[data-gal-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.zb-gal__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.zb-gal__thumb'));
    var dotsBox = root.querySelector('[data-gal-dots]');
    var counter = root.querySelector('[data-gal-counter]');
    if (!track || slides.length === 0) return;

    var dots = [];
    if (dotsBox) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Zdjęcie ' + (index + 1));
        if (index === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () { goTo(index); });
        dotsBox.appendChild(dot);
        dots.push(dot);
      });
    }

    function goTo(index) {
      var left = track.clientWidth * index;
      try {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } catch (error) {
        track.scrollLeft = left;
      }
      setActive(index);
    }

    function setActive(index) {
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { goTo(index); });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, index)));
      });
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var current = Math.round(track.scrollLeft / track.clientWidth);
      goTo(Math.max(0, Math.min(slides.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
    });

    setActive(0);
  })();

  /* ---------- 4. pakiety ---------- */
  var currencyCode = (document.querySelector('[data-product-controller]') || {}).dataset
    ? document.querySelector('[data-product-controller]').dataset.currency || 'PLN'
    : 'PLN';

  function money(cents) {
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currencyCode }).format((cents || 0) / 100);
    } catch (error) {
      return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  }
  window.ZBMoney = money;

  (function bundle() {
    var picker = document.querySelector('[data-bundle-picker]');
    if (!picker) return;
    var qtyInput = document.querySelector('[data-qty-input]');
    var node = document.querySelector('[data-variants-json]');
    var unit = 0;

    try {
      var variants = node ? JSON.parse(node.textContent) : [];
      var id = (document.querySelector('[data-variant-id]') || {}).value;
      var match = variants.filter(function (item) { return String(item.id) === String(id); })[0] || variants[0];
      unit = match ? Number(match.price) : 0;
    } catch (error) { unit = 0; }

    var rows = Array.prototype.slice.call(picker.querySelectorAll('.zb-opt'));

    function fill() {
      if (!unit) return;
      rows.forEach(function (row) {
        var qty = Number(row.dataset.qty || 1);
        var discount = Number(row.dataset.discount || 0);
        var full = unit * qty;
        var total = Math.round(full * (100 - discount) / 100);
        var saved = full - total;

        var totalEl = row.querySelector('.zb-opt__total');
        var unitEl = row.querySelector('.zb-opt__unit');
        var saveEl = row.querySelector('.zb-opt__save');

        if (totalEl) totalEl.textContent = money(total);
        if (unitEl) unitEl.textContent = qty > 1 ? money(Math.round(total / qty)) + ' / szt.' : '';
        if (saveEl) saveEl.textContent = saved > 0 ? 'oszczędzasz ' + money(saved) : '';
      });
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        rows.forEach(function (other) {
          var active = other === row;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', String(active));
        });
        if (qtyInput) qtyInput.value = row.dataset.qty || '1';
      });
    });

    fill();
  })();

  /* ---------- 5. modale ---------- */
  (function modals() {
    var root = document.querySelector('[data-modal-root]');
    if (!root) return;
    var sheet = root.querySelector('.zb-modal__sheet');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.zb-modal__panel'));
    var titleEl = root.querySelector('[data-modal-title]');
    var subEl = root.querySelector('[data-modal-sub]');
    var iconEl = root.querySelector('[data-modal-icon]');
    var lastFocus = null;

    function open(name) {
      var target = panels.filter(function (panel) { return panel.dataset.panel === name; })[0];
      if (!target) return;

      panels.forEach(function (panel) { panel.hidden = panel !== target; });
      if (titleEl) titleEl.textContent = target.dataset.title || 'Informacje';
      if (subEl) {
        subEl.textContent = target.dataset.sub || '';
        subEl.hidden = !target.dataset.sub;
      }
      if (iconEl) iconEl.innerHTML = '<i class="fa-solid ' + (target.dataset.icon || 'fa-circle-info') + '"></i>';

      var nav = document.getElementById('mobile-nav');
      if (nav) nav.classList.remove('is-active');
      var overlay = document.querySelector('[data-drawer-overlay]');
      if (overlay) overlay.classList.remove('is-active');

      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        var closeBtn = root.querySelector('.zb-modal__x');
        if (closeBtn) closeBtn.focus();
      });
    }

    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        root.hidden = true;
        panels.forEach(function (panel) { panel.hidden = true; });
        if (sheet) sheet.style.transform = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 260);
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-open-modal]');
      if (opener) {
        event.preventDefault();
        open(opener.getAttribute('data-open-modal'));
        return;
      }
      if (event.target.closest('[data-modal-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    /* przeciągnięcie w dół zamyka arkusz na telefonie */
    var head = root.querySelector('.zb-modal__head');
    var startY = null;
    function dragStart(event) { startY = event.touches[0].clientY; }
    function dragMove(event) {
      if (startY === null || !sheet) return;
      var delta = event.touches[0].clientY - startY;
      if (delta > 0) sheet.style.transform = 'translateY(' + delta + 'px)';
    }
    function dragEnd(event) {
      if (startY === null || !sheet) return;
      var delta = event.changedTouches[0].clientY - startY;
      startY = null;
      if (delta > 90) close();
      else sheet.style.transform = '';
    }
    [head, root.querySelector('.zb-modal__grip')].forEach(function (handle) {
      if (!handle) return;
      handle.addEventListener('touchstart', dragStart, { passive: true });
      handle.addEventListener('touchmove', dragMove, { passive: true });
      handle.addEventListener('touchend', dragEnd, { passive: true });
    });

    /* wejście z adresu, np. /#specyfikacja-modal */
    var hashMap = {
      '#wysylka': 'shipping', '#dostawa': 'shipping', '#shipping': 'shipping',
      '#specyfikacja-modal': 'specs', '#specs': 'specs',
      '#instrukcja': 'howto', '#howto': 'howto',
      '#zwroty': 'returns', '#returns': 'returns',
      '#kontakt': 'contact', '#contact': 'contact',
      '#polityka-prywatnosci': 'privacy', '#privacy': 'privacy'
    };
    function fromHash() {
      var name = hashMap[(location.hash || '').toLowerCase()];
      if (name) open(name);
    }
    window.addEventListener('hashchange', fromHash);
    if (location.hash) setTimeout(fromHash, 150);
  })();

  /* ---------- 6. formularz kontaktowy ---------- */
  (function contact() {
    var form = document.querySelector('[data-contact-form]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('.zb-form__submit');
      var done = form.querySelector('.zb-form__done');
      if (button) {
        button.disabled = true;
        button.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Wysyłanie...';
      }
      setTimeout(function () {
        if (button) button.hidden = true;
        if (done) done.hidden = false;
        form.reset();
      }, 520);
    });
  })();
})();
